<template>
  <section class="full_screen_loader" v-show="isShowLoader">
    Loading&#8230;
  </section>
</template>
<script>
export default {
  name: "LoaderFullScreen",
  props: {
    isShowLoader: {
      type: Boolean,
      required: true,
    }
  },
}
</script>
<style scoped>
.full_screen_loader {
  position: fixed;
  z-index: 1000;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.full_screen_loader:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0.3;
}

/* :not(:required) hides these rules from IE9 and below */
.full_screen_loader:not(:required) {
  /* hide "Loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.full_screen_loader:not(:required):after {
  content: '';
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 1800ms infinite linear;
  -moz-animation: spinner 1800ms infinite linear;
  -ms-animation: spinner 1800ms infinite linear;
  -o-animation: spinner 1800ms infinite linear;
  animation: spinner 1800ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(50, 74, 199, 1) 1.5em 0 0 0, rgba(50, 74, 199, 1) 1.1em 1.1em 0 0, rgba(50, 74, 199, 1) 0 1.5em 0 0, rgba(50, 74, 199, 1) -1.1em 1.1em 0 0, rgba(50, 74, 199, 1) -1.5em 0 0 0, rgba(50, 74, 199, 1) -1.1em -1.1em 0 0, rgba(50, 74, 199, 1) 0 -1.5em 0 0, rgba(50, 74, 199, 1) 1.1em -1.1em 0 0;
  box-shadow: rgba(50, 74, 199, 1) 1.5em 0 0 0, rgba(50, 74, 199, 1) 1.1em 1.1em 0 0, rgba(50, 74, 199, 1) 0 1.5em 0 0, rgba(50, 74, 199, 1) -1.1em 1.1em 0 0, rgba(50, 74, 199, 1) -1.5em 0 0 0, rgba(50, 74, 199, 1) -1.1em -1.1em 0 0, rgba(50, 74, 199, 1) 0 -1.5em 0 0, rgba(50, 74, 199, 1) 1.1em -1.1em 0 0;
}
</style>
